import Vue from 'vue'
import vSelect from 'vue-select'

import 'vue-select/dist/vue-select.css'

export default Vue.extend({
  components: {
    vSelect,
  },
  props: {
    value: {
      type: [String, Object, Array],
      default: '',
    },
    error: {
      type: String,
      default: '',
    },
    label: {
      type: String,
      required: false,
      default: '',
    },
    placeholder: {
      type: String,
      default: '',
    },
    extraClass: {
      type: String,
      required: false,
      default: '',
    },
    options: {
      type: Array,
      default() { return [] },
    },
    reduce: {
      type: Function,
      default: (value) => value,
    },
    multiple: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      OpenIndicator: {
        render: (createElement) => createElement('span'),
      },
    }
  },
  methods: {
    onInput(val) {
      this.$emit('input', val)
    },
  },
})
